/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MineableWords, MineableWordsInterface } from "../MineableWords";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC721",
        name: "_mineablePunks",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "mword",
        type: "uint256",
      },
    ],
    name: "BountyOffered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "mword",
        type: "uint256",
      },
    ],
    name: "BountyRemoval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "REMOVETHIS_getBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bn",
        type: "uint256",
      },
    ],
    name: "REMOVETHIS_setBlockNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "bounties",
    outputs: [
      {
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isClaimed",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "safeRemoveAfterBlockNumber",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "characters",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mword",
        type: "uint256",
      },
    ],
    name: "claimBounty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint88",
        name: "encoded",
        type: "uint88",
      },
    ],
    name: "decodeMword",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "data",
        type: "uint256",
      },
    ],
    name: "encodeMword",
    outputs: [
      {
        internalType: "uint88",
        name: "",
        type: "uint88",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint96",
        name: "nonce",
        type: "uint96",
      },
    ],
    name: "encodeNonce",
    outputs: [
      {
        internalType: "uint88",
        name: "",
        type: "uint88",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fees",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mword",
        type: "uint256",
      },
    ],
    name: "initiateBountyRemoval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "isMpunkOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mineablePunks",
    outputs: [
      {
        internalType: "contract IERC721",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint96",
        name: "nonce",
        type: "uint96",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mword",
        type: "uint256",
      },
    ],
    name: "offerBounty",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mword",
        type: "uint256",
      },
    ],
    name: "removeBounty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "data",
        type: "uint256",
      },
    ],
    name: "renderData",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "withdrawableBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MineableWords__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _mineablePunks: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MineableWords> {
    return super.deploy(
      _mineablePunks,
      overrides || {}
    ) as Promise<MineableWords>;
  }
  getDeployTransaction(
    _mineablePunks: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_mineablePunks, overrides || {});
  }
  attach(address: string): MineableWords {
    return super.attach(address) as MineableWords;
  }
  connect(signer: Signer): MineableWords__factory {
    return super.connect(signer) as MineableWords__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MineableWordsInterface {
    return new utils.Interface(_abi) as MineableWordsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MineableWords {
    return new Contract(address, _abi, signerOrProvider) as MineableWords;
  }
}
